import { render, staticRenderFns } from "./TaxContactBlock.vue?vue&type=template&id=cb622ab4&scoped=true"
import script from "./TaxContactBlock.vue?vue&type=script&lang=js"
export * from "./TaxContactBlock.vue?vue&type=script&lang=js"
import style0 from "./TaxContactBlock.vue?vue&type=style&index=0&id=cb622ab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb622ab4",
  null
  
)

export default component.exports